"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _reactRatingStarsComponent = _interopRequireDefault(require("react-rating-stars-component"));
var _Emoji = _interopRequireDefault(require("../Emoji"));
var _Button = _interopRequireDefault(require("../Button"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _Upload = _interopRequireDefault(require("../Upload"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _index = require("../index");
var _Chip = _interopRequireDefault(require("../Chip"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _utils = _interopRequireDefault(require("../utils/utils"));
var _cursor = _interopRequireDefault(require("../utils/cursor"));
var _forwardRef = _interopRequireDefault(require("../HOC/forwardRef"));
var _SendForm = _interopRequireDefault(require("./SendForm.style"));
var _dec, _class;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const ForwardTextField = (0, _forwardRef.default)(_TextField.default);
let SendForm = (_dec = (0, _reactJss.default)(_SendForm.default), _dec(_class = (0, _reactClickOutside.default)(_class = class SendForm extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      focus: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handlePasteImages = this.handlePasteImages.bind(this);
    this._saveCursorPosition = this._saveCursorPosition.bind(this);
    this.selectEmoji = this.selectEmoji.bind(this);
    this.selectSnippet = this.selectSnippet.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.refEdit = props.forwardRef || _react.default.createRef();
    this.refQuoteText = _react.default.createRef();
    this.sendFormRef = _react.default.createRef();
    // starting cursor position
    this.cursorPosition = 0;
    this.portalEl = document.createElement('div');
    this.portalEl.id = `${props.id}_filePreview`;
  }
  componentDidMount() {
    const {
      autoFocus
    } = this.props;
    this._isMounted = true;
    this.controls.parentNode.insertBefore(this.portalEl, this.controls);
    this.messageFormatting();
    this.optimizeQuoteSize();
    if (autoFocus) this._setCursor('end');
  }
  componentDidUpdate(prevProps) {
    if (prevProps.value.quote !== this.props.value.quote) {
      this.optimizeQuoteSize();
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  // Сохранить текущую позицию курсора
  _saveCursorPosition() {
    const pos = _cursor.default.getCaretPosition(this.refEdit.current);
    if (pos !== -1) {
      this.cursorPosition = pos;
    }
  }

  // Set cursor in specified position
  _setCursor(position) {
    setTimeout(() => {
      this.refEdit.current.focus();
      if (position === 'end') {
        _cursor.default.moveCursorToEnd(this.refEdit.current);
        this._saveCursorPosition();
      } else {
        this.cursorPosition = position;
        _cursor.default.moveCursorToPosition(this.refEdit.current, this.cursorPosition);
      }
    }, 10);
  }

  // Add/remove flag for showing/hiding + buttons Show more in dependence of quote size
  optimizeQuoteSize() {
    const {
      showMore
    } = this.state;
    const maxQuoteHeight = 3 * 22;
    if (!this.refQuoteText.current) return;
    const {
      height
    } = this.refQuoteText.current.getBoundingClientRect();
    if (height > maxQuoteHeight && !showMore) {
      this.setState({
        showMore: 'hide'
      });
    } else if (height <= maxQuoteHeight && showMore) {
      this.setState({
        showMore: null
      });
    }
  }
  formatStr(str) {
    const regBr = new RegExp('<br>', 'gi');
    const regSpan = new RegExp('\\<span.*?\\>(.*?)\\<\\/span\\>', 'g');
    const regSpan1 = new RegExp('\\[span.*?\\](.*?)\\[\\/span\\]', 'g');
    const replacedStr = str.replace(regBr, '\n').replace(regSpan, '$1').replace(regSpan1, '$1');
    const {
      message
    } = this.highlightAttachments(replacedStr);
    return message;
  }

  // Formatting of comment
  messageFormatting() {
    const {
      value
    } = this.props;
    const message = this.formatStr(value.message);
    if (value.message !== message) {
      var _messageBeforeCursorP;
      const messageBeforeCursorPos = this.formatStr(value.message.slice(0, this.cursorPosition));
      const brCountBeforeCursorpos = ((_messageBeforeCursorP = messageBeforeCursorPos.match(/<br\s*\/?>/gi)) === null || _messageBeforeCursorP === void 0 ? void 0 : _messageBeforeCursorP.length) || 0;
      this.handleChange([{
        id: 'message',
        value: message,
        error: false
      }]);
      this._setCursor(this.cursorPosition - brCountBeforeCursorpos || 'end');
    }
  }

  // Handle click outside component
  handleClickOutside() {
    this.setState({
      focus: false
    });
  }

  // Handle form submit
  handleSubmit() {
    const {
      id,
      value,
      error,
      onSubmit
    } = this.props;
    const formatValue = this.formatAndCheck(value);
    onSubmit({
      id,
      value: formatValue,
      error
    });
  }

  // Format values on submit
  formatAndCheck(value) {
    return _objectSpread(_objectSpread({}, value), {}, {
      message: _utils.default.brToN(value.message),
      sign: value.sign,
      rating: value.rating,
      done: value.done,
      reject: value.reject
    });
  }

  // Handle change message and files
  handleChange(e) {
    e = Array.isArray(e) ? e : [e];
    const {
      id,
      value,
      onChange
    } = this.props;
    const newValue = _objectSpread({}, value);
    let error = false;
    e.forEach(el => {
      newValue[el.id] = el.value;
      error = error || el.error;
    });
    onChange({
      id,
      value: newValue,
      error
    });
  }
  handleKeyDown(e) {
    const {
      onKeyDown,
      submitOnEnter
    } = this.props;
    const isEnter = e.key === 'Enter';
    const isModifierKeyPressed = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
    if (isEnter) {
      e.preventDefault();
      if (submitOnEnter && !isModifierKeyPressed) {
        this.handleSubmit();
      } else {
        _cursor.default.fixLineBreak(e);
      }
    }
    onKeyDown(e);
  }
  handleKeyUp(e) {
    const {
      onKeyUp
    } = this.props;
    this._saveCursorPosition();
    if (e.key === ' ' || e.key === 'Backspace') {
      this.messageFormatting();
    }
    onKeyUp(e);
  }
  handleFocus() {
    this.setState({
      focus: true
    });
  }
  handlePasteImages({
    value: files
  }) {
    const {
      value
    } = this.props;
    const newFiles = value.files.concat(files);
    this.handleChange({
      id: 'files',
      value: newFiles,
      error: false
    });
  }
  insertToHtml(html) {
    const selection = window.getSelection();
    const textNode = document.createTextNode(html);
    if (!selection.focusNode || selection.focusNode.parentNode !== this.refEdit.current) {
      this.refEdit.current.appendChild(textNode);
    } else {
      const range = selection.getRangeAt(0);
      range.deleteContents();
      range.insertNode(textNode);
      const _range = range.cloneRange();
      _range.setStartAfter(textNode);
      _range.collapse(true);
      selection.removeAllRanges();
      selection.addRange(_range);
    }
    this.refEdit.current.dispatchEvent(new Event('input', {
      bubbles: true
    }));
  }
  insertToText(attachment) {
    const {
      value
    } = this.props;
    const clearMessage = this.makeClearMessage(value.message);
    const matchLieBreak = clearMessage.match(/\n/g);
    const lineBreakLen = matchLieBreak ? matchLieBreak.length : 0;
    const cursorPos = this.cursorPosition + lineBreakLen;
    const firstPart = clearMessage.substring(0, cursorPos);
    const lastPart = clearMessage.substring(cursorPos);
    const newMessage = `${firstPart}${attachment}${lastPart}`;
    const {
      message
    } = this.highlightAttachments(newMessage);
    this.handleChange([{
      id: 'message',
      value: message,
      error: false
    }]);
    this._setCursor(`${firstPart}${attachment}`.length - lineBreakLen);
  }

  // Select emoji
  selectEmoji(emoji) {
    const {
      contentType
    } = this.props;
    const unifiedCodePoints = emoji.unified.split('-').map(hex => parseInt(hex, 16));
    const smile = String.fromCodePoint(...unifiedCodePoints);
    if (contentType === 'html') {
      this._setCursor(this.cursorPosition || 'end');
      setTimeout(() => this.insertToHtml(smile), 100);
    } else {
      this.insertToText(`${smile} `);
    }
  }

  // Insert snippet
  selectSnippet({
    value: text
  }) {
    const {
      contentType
    } = this.props;
    this._setCursor(this.cursorPosition || 'end');
    if (contentType === 'html') {
      setTimeout(() => {
        this.insertToHtml(text);
        const newCursorPosition = this.cursorPosition ? this.cursorPosition + text.length : 'end';
        this._setCursor(newCursorPosition);
      }, 100);
    } else {
      this.insertToText(`${text} `);
    }
  }

  // Remove all html tags from comment string
  makeClearMessage(sourceMessage) {
    const regBr = new RegExp('<br>', 'gi');
    const regSpan = new RegExp('\\<span.*?\\>(.*?)\\<\\/span\\>\\&nbsp\\;', 'g');
    return sourceMessage.replace(regBr, '\n').replace(regSpan, '$1 ');
  }

  // Parse comment string, select emoji and users
  highlightAttachments(sourceMessage) {
    // Transforming new lines
    const regBr = new RegExp('\n', 'gi'); // eslint-disable-line no-control-regex
    const message = sourceMessage.replace(regBr, '<br>');
    return {
      message
    };
  }
  renderSign() {
    const {
      classes
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      className: classes.sign,
      label: "Signed",
      type: "rectangular",
      icon: "sign",
      closeClick: () => this.handleChange({
        id: 'sign',
        value: false
      })
    });
  }
  renderDone() {
    const {
      classes
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      className: classes.done,
      label: "Done",
      type: "rectangular",
      icon: "check_box",
      closeClick: () => this.handleChange({
        id: 'done',
        value: false
      })
    });
  }
  renderReject() {
    const {
      classes
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      className: classes.reject,
      label: "Rejected",
      type: "rectangular",
      icon: "add",
      closeClick: () => this.handleChange({
        id: 'reject',
        value: false
      })
    });
  }
  renderRate(value) {
    const {
      classes
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      type: "rectangular",
      className: classes.rating,
      closeClick: () => this.handleChange({
        id: 'rating',
        value: false
      })
    }, /*#__PURE__*/_react.default.createElement(_reactRatingStarsComponent.default, {
      count: 5,
      size: 14,
      half: false,
      value: value,
      color1: '#ACB3BE',
      color2: '#FFA701',
      onChange: value => this.handleChange({
        id: 'rating',
        value
      })
    }));
  }
  renderQuote(text) {
    const {
      classes
    } = this.props;
    const {
      showMore
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.quote
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.controlsIconsItem, 'quotationMark'),
      type: "quote",
      size: "medium"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.quoteWrap
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: this.refQuoteText,
      className: (0, _clsx.default)(classes.quoteText, {
        hidden: showMore === 'hide'
      })
    }, text), showMore ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: classes.quoteShowBtn,
      size: "small",
      type: "text",
      label: showMore === 'hide' ? 'Show more' : 'Show less',
      onClick: () => this.setState({
        showMore: showMore === 'hide' ? 'show' : 'hide'
      })
    }) : null), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.controlsIconsItem, 'quotationCancel'),
      type: "close",
      size: "small",
      onClick: () => this.handleChange({
        id: 'quote',
        value: ''
      })
    }));
  }
  renderSnippets() {
    const {
      snippetsItems
    } = this.props;
    const SnippetsComponent = snippetsItems({
      onClick: this.selectSnippet
    });
    return SnippetsComponent || null;
  }
  render() {
    const {
      focus
    } = this.state;
    const {
      id,
      classes,
      className,
      visibility,
      placeholder,
      value,
      contentType,
      sendButtonLabel,
      cancelButtonLabel,
      autoFocus,
      error,
      options,
      onCancel,
      maxFileSize,
      maxFileSizeErrorText,
      onKeyPress,
      onClickForm,
      onClickSnippets,
      artifacts,
      customControls,
      rows,
      dataTestId
    } = this.props;
    const formClasses = (0, _clsx.default)(className, classes.sendForm, {
      focus
    }, {
      error: !!error
    }, {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    });
    const isMobile = _utils.default.isMobile();
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: formClasses,
      ref: this.sendFormRef,
      "data-testid": dataTestId
    }, value.quote && value.quote.length ? this.renderQuote(value.quote) : null, /*#__PURE__*/_react.default.createElement(ForwardTextField, {
      ref: this.refEdit,
      id: "message",
      className: classes.input,
      autoFocus: autoFocus,
      visibility: visibility,
      value: value.message,
      placeholder: placeholder,
      onChange: e => this.handleChange(e, 'message'),
      onFocus: this.handleFocus,
      onKeyDown: this.handleKeyDown,
      onKeyPress: onKeyPress,
      onKeyUp: this.handleKeyUp,
      onBlur: this._saveCursorPosition,
      onUpload: this.handlePasteImages,
      multiline: true,
      multilineType: contentType,
      rows: rows,
      dataTestId: dataTestId ? `${dataTestId}-input` : undefined
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.artifacts
    }, value.sign ? this.renderSign() : null, value.rating && value.rating !== 0 ? this.renderRate(value.rating) : null, value.done ? this.renderDone() : null, value.reject ? this.renderReject() : null, artifacts), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.controls,
      ref: el => this.controls = el
    }, /*#__PURE__*/_react.default.createElement(_Stack.default.H, {
      className: classes.controlsIcons,
      alignItems: "center",
      fullWidth: true
    }, options.smiles ? /*#__PURE__*/_react.default.createElement(_Emoji.default, {
      className: classes.controlsIconsItem,
      visibility: visibility,
      size: "medium",
      onChange: ({
        value
      }) => this.selectEmoji(value),
      bindingElementRef: this.sendFormRef
    }) : null, options.files ? /*#__PURE__*/_react.default.createElement(_Upload.default, {
      id: "files",
      visibility: visibility,
      className: classes.controlsIconsItem,
      multiple: options.files.multiple,
      preview: options.files.preview,
      accept: options.files.accept,
      value: value.files,
      portal: this.portalEl,
      maxFileSize: maxFileSize,
      maxFileSizeErrorText: maxFileSizeErrorText,
      onChange: e => this.handleChange(e, 'files'),
      uploadingFiles: options.uploadingFiles
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: 'attach',
      size: "medium"
    })) : null, options.rating || options.sign || options.done || options.reject || options.form ? /*#__PURE__*/_react.default.createElement(_index.Divider, {
      style: {
        height: '20px'
      },
      orientation: _index.Divider.ORIENTATION.horizontal
    }) : null, options.rating ? /*#__PURE__*/_react.default.createElement(_index.Tooltip, {
      value: "Rate"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: classes.controlsIconsItem,
      type: 'star_full',
      size: "medium",
      onClick: () => this.handleChange([{
        id: 'reject',
        value: false
      }, {
        id: 'done',
        value: false
      }, {
        id: 'sign',
        value: false
      }, {
        id: 'rating',
        value: 1
      }])
    })) : null, options.sign ? /*#__PURE__*/_react.default.createElement(_index.Tooltip, {
      value: "Sign"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: classes.controlsIconsItem,
      type: 'sign',
      size: "medium",
      onClick: () => this.handleChange([{
        id: 'reject',
        value: false
      }, {
        id: 'done',
        value: false
      }, {
        id: 'sign',
        value: true
      }, {
        id: 'rating',
        value: 0
      }])
    })) : null, options.done ? /*#__PURE__*/_react.default.createElement(_index.Tooltip, {
      value: "Done"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: classes.controlsIconsItem,
      type: 'check_box',
      size: "medium",
      onClick: () => {
        this.handleChange([{
          id: 'reject',
          value: false
        }, {
          id: 'done',
          value: true
        }, {
          id: 'sign',
          value: false
        }, {
          id: 'rating',
          value: 0
        }]);
      }
    })) : null, options.reject ? /*#__PURE__*/_react.default.createElement(_index.Tooltip, {
      value: "Reject"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.controlsIconsItem, 'reject'),
      type: 'add',
      size: "medium",
      onClick: () => {
        this.handleChange([{
          id: 'reject',
          value: true
        }, {
          id: 'done',
          value: false
        }, {
          id: 'sign',
          value: false
        }, {
          id: 'rating',
          value: 0
        }]);
      }
    })) : null, options.form ? /*#__PURE__*/_react.default.createElement(_index.Tooltip, {
      value: "Script"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.controlsIconsItem, 'form_pole'),
      type: 'form_pole',
      size: "medium",
      onClick: onClickForm
    })) : null, options.snippets ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_index.Tooltip, {
      value: "Snippets"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.controlsIconsItem, 'snippets'),
      type: 'snippet',
      size: "medium",
      onClick: onClickSnippets
    })), this.renderSnippets()) : null, _react.default.isValidElement(customControls) ? customControls : null), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.controlsBtn
    }, cancelButtonLabel ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      size: "small",
      type: "text",
      label: cancelButtonLabel,
      onClick: () => onCancel({
        id,
        value,
        error
      })
    }) : null, sendButtonLabel ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      size: "small",
      label: isMobile ? '' : sendButtonLabel,
      onClick: this.handleSubmit,
      rounded: isMobile,
      icon: isMobile ? 'send' : null,
      dataTestId: dataTestId ? `${dataTestId}-send-button` : undefined,
      visibility: !error && (value.message.replace(/<br>/g, '').trim().length || value.files && value.files.length || value.rating || value.sign || value.done || value.reject) || artifacts ? 'visible' : 'disabled'
    }) : null)));
  }
}) || _class) || _class);
SendForm.defaultProps = {
  visibility: 'visible',
  error: false,
  contentType: 'text',
  value: {
    message: '',
    files: [],
    sign: false,
    done: false,
    reject: false,
    rating: 0,
    quote: ''
  },
  sendButtonLabel: 'Send',
  customControls: null,
  options: {
    smiles: {},
    snippets: false,
    files: {
      multiple: true,
      preview: true
    },
    sign: false,
    rating: false,
    done: false,
    reject: false
  },
  snippetsItems: () => {},
  onSubmit: () => {},
  onCancel: () => {},
  onChange: () => {},
  onKeyDown: () => {},
  onKeyUp: () => {},
  onKeyPress: () => {}
};
var _default = exports.default = SendForm;